'use strict';
var EventEmitter = require('events').EventEmitter;

import GC from "./const";

var SceneSystemPreface = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function SceneSystemPreface ()
  {
    Phaser.Scene.call(this, { key: 'sceneSystemPreface', active: false });
  },

  init: function(params){
    var self = this;
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.sceneBoot.currentScene = 'sceneSystemPreface';

    this.sceneBoot.scaleMode = 'height';
    this.scaler.scaleMode = 'height';

    this.scene.bringToTop();

    for(var key in EventEmitter.prototype){
      this.__proto__[key] = EventEmitter.prototype[key];
    }

    this.scrollerBounds = {
      top: 306,
      bottom: 1024,
    };
    this.dragSprites = [];
    
    this.allowDown = false;
    this.allowUp = true;

    // this.on('dragstart-system-preface', function () {
    //   this.dragSprites.map(sprite => {
    //     sprite.keepData.x = sprite.x;
    //     sprite.keepData.y = sprite.y;
    //   });

    //   if(this.autoScrollerTimer) {
    //     this.autoScrollerTimer.destroy();
    //   }
    //   if(this.reScrollerTimer) {
    //     this.reScrollerTimer.destroy();
    //   }
    // });
  
    // this.on('drag-system-preface', function(evt) {
    //   if(evt.offset < 0 && this.allowUp == false)
    //     return;
    //   if(evt.offset > 0 && this.allowDown == false)
    //     return;
    //   let v = 2;
    //   this.dragSprites.map(sprite => {
    //     sprite.y = sprite.keepData.y + evt.offset * v;
    //   });
    // });
  
    // this.on('dragend-system-preface', function(evt) {
    //   this.dragSprites.map(sprite => {
    //     sprite.alpha = sprite.keepData.alpha;
    //   });

    //   if(this.reScrollerTimer) {
    //     this.reScrollerTimer.destroy();
    //   }
    //   this.reScrollerTimer = this.time.delayedCall(3000, function(){
    //     self.lastAllowUp = false;
    //   }, this);
    // }, this);
  
    // this.on('wheel-system-preface', function(evt) {
    //   if(evt.offset < 0 && this.allowUp == false)
    //     return;
    //   if(evt.offset > 0 && this.allowDown == false)
    //     return;
    //   let v = 2;
    //   this.dragSprites.map(sprite => {
    //     sprite.keepData.y = sprite.y;
    //     sprite.y = sprite.keepData.y - evt.offset * v;
    //   });
    // });

    this.rightButtonsAnimationStart = false;
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    designX = 0;
    designY = 0;
    sprite = this.add.rectangle(
      this.scaler.scaleX(this.scaler.designRefWidth()/2 + designX),
      this.scaler.scaleY(this.scaler.designRefHeight()/2 + designY),
      this.scaler.designRefWidth(),
      this.scaler.designRefHeight()
      , 0xffffff, 1);
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSpriteFill(sprite);
    sprite.keepData = {
      resized: true,
      fill: true,
      xlocation: 'center',
      ylocation: 'center',
      designX: designX,
      designY: designY
    };
    this.bgSprite = sprite;
    this.bgSprite.visible = false;

    designX = 0;
    designY = 0;
    sprite = this.add.rectangle(
      this.scaler.scaleX(this.scaler.designRefWidth()/2 + designX),
      this.scaler.scaleY(this.scaler.designRefHeight()/2 + designY),
      this.scaler.designRefWidth(),
      this.scaler.designRefHeight()
      , 0x0000ff, 1);
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSpriteFill(sprite);
    sprite.keepData = {
      resized: true,
      fill: true,
      xlocation: 'center',
      ylocation: 'center',
      designX: designX,
      designY: designY
    };
    this.blueBgSprite = sprite;
    this.blueBgSprite.visible = false;
    
    designX = window.sidebarOffset;
    designY = 0;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX),
      this.scaler.scaleY(designY),
      'title'
    );
    sprite.setOrigin(0, 0);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'left',
      ylocation: 'top',
      designX: designX,
      designY: designY,
      offset: 'x',
      initialX: 0,
    };
    this.titleSprite = sprite;
    sprite.visible = false;

    designX = -683;
    designY = 609.5;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'bg_preface'
    );
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      x: sprite.x,
      y: sprite.y
    };
    this.bgPrefaceSprite = sprite;

    sprite.setInteractive({ draggable: true });

    // sprite.on('dragstart', function (pointer, dragX, dragY) {
    //   // console.log(`drag start.. ${pointer.x} ${pointer.y}`);
    //   this.bgPrefaceSprite.keepData.x = this.bgPrefaceSprite.x;
    //   this.bgPrefaceSprite.keepData.y = this.bgPrefaceSprite.y;
    //   this.emit('dragstart-system-preface');
    // }, this);
  
    // sprite.on('drag', function (pointer, dragX, dragY) {
    //   // console.log(dragX, this.bgPrefaceSprite.keepData.x);
    //   // check whether out area
    //   if(self.scaler.getDirection() == 'Horizontal'){
    //     this.emit('drag-system-preface', {offset: dragY - this.bgPrefaceSprite.keepData.y});
    //   } else{
    //     this.emit('drag-system-preface', {offset: (this.bgPrefaceSprite.keepData.x - dragX)});
    //   }
  
    // }, this);
  
    // sprite.on('dragend', function (pointer, dragX, dragY) {
    //   // console.log('drag end');
    //   this.emit('dragend-system-preface');
    // }, this);
  
    // sprite.on('wheel', function (pointer, deltaX, deltaY, deltaZ) {
    //   this.emit('wheel-system-preface', {offset: deltaY * 0.4});
    // }, this);

    designX = 0;
    designY = 0;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(this.scaler.designRefHeight()/2 + designY),
      'system_preface_' + this.params.systemIndex
    );
    sprite.setOrigin(1, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      ylocation: 'center',
      designX: designX,
      designY: designY,
      y: sprite.y,
    };
    this.prefaceSprite = sprite;

    // designX = -1217;
    // designY = 298.5;
    // var sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'system_preface_content_' + this.params.systemIndex
    // );
    // sprite.setOrigin(0, 0);
    // this.scaler.scaleSprite(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY
    // };
    // this.contentPrefaceSprite = sprite;
    // this.dragSprites.push(sprite);

    // designX = -1239;
    // designY = 115;
    // sprite = this.add.image(
    //   this.scaler.scaleBgX(designX, 'right'),
    //   this.scaler.scaleY(designY),
    //   'btn_lan_cn');
    // sprite.setOrigin(0.5, 0.5);
    // this.scaler.scaleSpriteByHeight(sprite);
    // sprite.keepData = {
    //   resized: true,
    //   xlocation: 'right',
    //   designX: designX,
    //   designY: designY,
    //   enableClick: true,
    //   alpha: 1,
    // };
    // this.btnLanSprite = sprite;

    // sprite.setInteractive();

    // sprite.on("pointerdown", pointer => {
    //   this.btnLanSprite.setAlpha(0.5);
    // });

    // sprite.on("pointerup", pointer => {
    //   this.btnLanSprite.setAlpha(1.0);

    //   this.changeLanguage();
    // });
 
    designX = -1434;
    designY = 606;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'btn_left');
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSpriteByHeight(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    this.btnLeftSprite = sprite;

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      this.btnLeftSprite.setAlpha(0.5);
      this.btnLeftSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      this.btnLeftSprite.setAlpha(1.0);

      if(this.btnLeftSprite.isPressed) {
        this.back();
      }

      this.btnLeftSprite.isPressed = false;
    });

    this.btnRightSprites = [];
    if(!GC.onlyGraduate.includes(this.params.systemIndex)) {
      designX = 0;
      designY = 30;
      sprite = this.add.image(
        this.scaler.scaleBgX(designX, 'right'),
        this.scaler.scaleY(designY),
        'btn_undergradute');
      sprite.setOrigin(1, 0);
      this.scaler.scaleSpriteByHeight(sprite);
      sprite.keepData = {
        resized: true,
        xlocation: 'right',
        designX: designX,
        designY: designY,
        enableClick: true,
        alpha: 1,
      };
      this.btnUndergraduteSprite = sprite;
  
      sprite.setInteractive();
  
      sprite.on("pointerdown", pointer => {
        this.btnUndergraduteSprite.setAlpha(0.5);
        this.btnUndergraduteSprite.isPressed = true;
      });
  
      sprite.on("pointerup", pointer => {
        this.btnUndergraduteSprite.setAlpha(1.0);
  
        if(this.btnUndergraduteSprite.isPressed) {
          this.nextPage(0, true);
        }

        this.btnUndergraduteSprite.isPressed = false;
      });

      designX = -64 - 14;
      designY = 355.5;
      sprite = this.add.image(
        this.scaler.scaleBgX(designX, 'right'),
        this.scaler.scaleY(designY),
        'btn_right_green');
      sprite.setOrigin(0.5, 0.5);
      this.scaler.scaleSpriteByHeight(sprite);
      sprite.keepData = {
        resized: true,
        xlocation: 'right',
        designX: designX,
        designY: designY
      };

      this.btnRightSprites.push(sprite);
    }

    designX = 0;
    designY = -30;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(this.scaler.designRefHeight() + designY),
      'btn_graduate');
    sprite.setOrigin(1, 1);
    this.scaler.scaleSpriteByHeight(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      ylocation: 'bottom',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    this.btnGraduateSprite = sprite;

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      this.btnGraduateSprite.setAlpha(0.5);

      this.btnGraduateSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      this.btnGraduateSprite.setAlpha(1.0);

      if(this.btnGraduateSprite.isPressed) {
        this.nextPage(1, true);
      }

      this.btnGraduateSprite.isPressed = false;
    });

    designX = -64 - 14;
    designY = 1012.5;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'btn_right_pink');
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSpriteByHeight(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY
    };
    this.btnRightSprites.push(sprite);

    this.input.on('pointerup', function () {
      utils.updateButtonsAlpha(this);
    }, this);
    
    this.sceneBoot.windowResized = true;

    utils.disableAllButtons(this);
    if(this.params.backToArea) {
      this.transitionAnimation(function() {
        self.time.delayedCall(400, function(){  
          self.backAnimation();
        }, this);
      });
    } else if(this.params.backToSwitch) { // 本研切换
      this.blueBgSprite.visible = true;
      this.transitionAnimation(function() {
        if(self.params.categoryIndex == 0) {
          self.nextPage(1, true);
        } else if(self.params.categoryIndex == 1) {
          self.nextPage(0, true);
        }
      });
    } else if(this.params.autoJump == 'personal') {
      self.nextPage(self.params.categoryIndex);
    } else if(this.params.autoJump == 'system') {
      this.enterAnimation(function() {
        utils.enableAllButtons(self);

        self.rightButtonsAnimationStart = true;
        self.btnRightSprites.forEach(sprite => {
          self.btnRightAnimation(sprite);
        });
      });
    } else {
      this.enterAnimation(function() {
        utils.enableAllButtons(self);
        // self.autoScroller();

        // self.reScrollerTimer = self.time.delayedCall(5000, function(){
        //   self.lastAllowUp = false;
        // }, this);

        self.rightButtonsAnimationStart = true;
        self.btnRightSprites.forEach(sprite => {
          self.btnRightAnimation(sprite);
        });
      });
    }
  },

  update: function(){
    // this.checkEnding();
    // this.updateScrollerArea();
  },

  resized: function () {
    var w = this.scaler.width;
    var h = this.scaler.height;
    if(this.scaler.width < this.scaler.height) {
      w = this.scaler.height;
      h = this.scaler.width;
    }
    if(w/h < 1.14) {
      this.prefaceSprite.keepData.scale = 0.85;
      this.prefaceSprite.keepData.designX = 30;

      this.btnLeftSprite.keepData.designX = -1434 + 250;
    } else if(w/h < 1.22) {
      this.prefaceSprite.keepData.scale = 0.9;
      this.prefaceSprite.keepData.designX = 50;

      this.btnLeftSprite.keepData.designX = -1434 + 200;
    } else if(w/h < 1.35) {
      this.prefaceSprite.keepData.scale = 0.9;
      this.prefaceSprite.keepData.designX = 40;

      this.btnLeftSprite.keepData.designX = -1434 + 150;
    } else {
      this.prefaceSprite.keepData.scale = 1;
      this.prefaceSprite.keepData.designX = 0;

      this.btnLeftSprite.keepData.designX = -1434;
    }

    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.keepData.offset == 'x') {
          s.keepData.designX = s.keepData.initialX + window.sidebarOffset;
        }

        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSpriteByMax(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'center');
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'right');
          } else{
            s.x = this.scaler.scaleBgX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else{
            this.scaler.scaleSprite(s);
          }

          if(s.keepData.width){
            s.displayWidth = s.keepData.width * this.scaler.vScale();
          }
          if(s.keepData.height){
            s.displayHeight = s.keepData.height * this.scaler.vScale();
          }

          if(s.keepData.scale != undefined) {
            s.scale *= s.keepData.scale;
          }
        }
      }
    }

    if(this.rightButtonsAnimationStart) {
      this.btnRightSprites.forEach(sprite => {
        this.btnRightAnimation(sprite);
      });
    }
  },

  changeLanguage: function() {
    if(this.titlePrefaceSprite.texture.key.indexOf('system_preface_title_cn') >= 0) {
      this.btnLanSprite.setTexture('btn_lan_en');
      this.titlePrefaceSprite.setTexture('system_preface_title_en_' + this.params.systemIndex);
      this.contentPrefaceSprite.setTexture('system_preface_content_en_' + this.params.systemIndex);
    } else {
      this.btnLanSprite.setTexture('btn_lan_cn');
      this.titlePrefaceSprite.setTexture('system_preface_title_cn_' + this.params.systemIndex);
      this.contentPrefaceSprite.setTexture('system_preface_content_cn_' + this.params.systemIndex);
    }
  },

  back: function() {
    utils.disableAllButtons(this);

    this.backAnimation();
  },

  nextPage: function(categoryIndex, animation) {
    utils.disableAllButtons(this);

    this.scene.get('sceneAnimation').hide();
    
    this.btnRightSprites.forEach(sprite => {
      if(sprite.tween) {
        sprite.tween.remove();
      }
    });

    var self = this;
    window.custom.selected.categoryIndex = categoryIndex;
    this.scene.get('sceneArea').scene.stop();

    if(animation) {
      this.outAnimation(function() {
        self.toMainPage(categoryIndex);
      });

      this.scene.launch('sceneSideBar', {
        systemIndex: this.params.systemIndex,
        categoryIndex: categoryIndex,
      });

      this.scene.get('sceneLoading').setLoadingProgress(0);
    } else {
      this.scene.stop();
      this.scene.launch('sceneSideBar', {
        systemIndex: this.params.systemIndex,
        categoryIndex: categoryIndex,
        noAnimation: true
      });
  
      this.scene.get('sceneLoading').setLoadingProgress(0);
      this.toMainPage(categoryIndex);
    }    
  },

  toMainPage: function(categoryIndex) { // 0->本科生, 1->研究生
    var self = this;
    var systemList = window.custom.systemList;
    
    var system = GC.systemNames[this.params.systemIndex];
    var category = ['本科生', '研究生'][categoryIndex];

    var latest = '';
    for(var key in systemList){
      if(systemList[key].label.indexOf(system) >= 0 && systemList[key].label.indexOf(category) >= 0){
        latest = systemList[key].latest;
        break;
      }
    }

    $.ajax({
      url: latest,
      type: "GET",
      async: true,
      success: function(data) {
        console.log('GET IMAGES SUCCESS!');
        let regionsRaw = data.regions;

        window.publicPath = data.publicPath;
        window.theme = data.theme;
        // self.getSystem(data.label);

        //remove avatar
        // regionsRaw.forEach(region => {
        //   if(region.meta.avatar && region.meta.avatar.texture) {
        //     for(var texture in region.preloadMaterials.images) {
        //       if(texture == region.meta.avatar.texture) {
        //         delete region.preloadMaterials.images[texture]
        //       }
        //     }
        //   }
          
        // });

        utils.setCookie('selected', encodeURIComponent(JSON.stringify(window.custom.selected)));
        if(window.custom.locator == null){
          utils.setCookie('locator', regionsRaw[0].meta.locator);
        }

        self.scene.launch('sceneMain', {
          regions: regionsRaw,
          theme: window.theme,
          multiple: 'multiple'
        });
        console.log('TO MAIN SCENE!!!');
      }, error : function(response) {
        console.log("GET IMAGES FAILED!");
        console.log(JSON.stringify(response));
      }
    });
  },

  // 打开
  enterAnimation: function(func) {
    var self = this;

    utils.slideAimation(this, 'in', function() {
      self.scene.get('sceneTitle').scene.setVisible(false);
      self.bgSprite.visible = true;
      self.titleSprite.visible = true;
      if(func) {
        func();
      }
    });
  },

  // 关闭
  backAnimation: function() {
    const self = this;
    this.scene.get('sceneTitle').scene.setVisible(true);
    this.bgSprite.visible = false;
    this.titleSprite.visible = false;

    utils.slideAimation(this, 'back', function() {
      self.scene.stop();
      self.scene.get('sceneAnimation').show();
      self.scene.get('sceneArea').scene.resume();  
    });

    // this.scene.get('sceneAnimation').enterAnimation(0, 800);
  },

  // 进入长廊页
  outAnimation: function(func) {
    var self = this;

    var phaserElements = this.children.list;
    phaserElements.forEach(sprite => {
      if(sprite.keepData.resized) {
        sprite.keepData.resized = false;
      }
    });

    utils.slideAimation(this, 'out', function() {
      self.scene.stop();
      if(func) {
        func();
      }
    });
  },

  // 长廊页返回过渡动画
  transitionAnimation: function(func) {
    var self = this;
    this.bgSprite.visible = true;
    this.titleSprite.visible = true;

    utils.slideAimation(this, 'leftIn', function() {
      if(func) {
        func();
       }
    });
  },

  checkEnding: function () {
    if(this.dragSprites[0].height < this.scrollerBounds.bottom - this.scrollerBounds.top) {
      return;
    }
    var self = this;
    var minY, maxY;
    var sprites = this.dragSprites;
    if(sprites.length <= 0)
      return;
    minY = sprites[0].y;
    maxY = sprites[sprites.length - 1].y + sprites[sprites.length - 1].displayHeight;

    var top = this.scaler.scaleY(this.scrollerBounds.top);
    var bottom = this.scaler.scaleY(this.scrollerBounds.bottom);
  
    if(minY >= top && maxY < bottom){
      this.allowDown = false;
      this.allowUp = false;
      return;
    }
  
    if(minY >= top){
      this.allowDown = false;
  
      var offset = minY - top;
      sprites.map(sprite => {
        sprite.y -= offset; 
      });
  
    } else{
      this.allowDown = true;
    }
  
    if(maxY <= bottom){
      this.allowUp = false;
  
      if(minY < top){
        var offset = bottom - maxY;
        sprites.map(sprite => {
          sprite.y += offset; 
        });
      }
  
    } else{
      this.allowUp = true;
    }

    if(this.lastAllowUp && this.allowUp == false) {
      if(this.restartScrollerTimer) {
        this.restartScrollerTimer.destroy();
      }
      if(this.autoScrollerTimer) {
        this.autoScrollerTimer.destroy();
      }
      this.restartScrollerTimer = this.time.delayedCall(3000, function(){  
        self.restartScrollerAnimation();
      }, this);
    }

    if(this.lastAllowUp == false && this.allowUp == true) {
      if(this.restartScrollerTimer) {
        this.restartScrollerTimer.destroy();
      }
      this.autoScroller();
    }

    this.lastAllowUp = this.allowUp;
  },  

  updateScrollerArea: function(){
    var top = this.scrollerBounds.top;
    var bottom = this.scrollerBounds.bottom;

    var offset = this.scaler.offsetPos().y;
    if(this.scaler.getDirection() != 'Horizontal') {
      offset = this.scaler.offsetPos().x;
    }
    this.dragSprites.map(sprite => {
      var y0 = (sprite.y - offset)/this.scaler.vScale();
      var cropX = 0;
      var cropWidth = sprite.width;
      
      var cropHeight = bottom - top;
      if(cropHeight > sprite.height) {
        cropHeight = sprite.height;
      }
      
      var cropY = top - y0;
      if(cropY < 0) {
        cropY = 0;
      }
      sprite.setCrop(cropX, cropY, cropWidth, cropHeight);
    });
  },

  autoScroller: function() {
    if(this.dragSprites[0].height < this.scrollerBounds.bottom - this.scrollerBounds.top) {
      return;
    }
    if(this.autoScrollerTimer) {
      this.autoScrollerTimer.destroy();
    }
    this.autoScrollerTimer = this.time.addEvent({
      delay: 1000/30,
      callback: function(){
        this.dragSprites.forEach(sprite => {
          sprite.y -= this.scaler.vScale() * 0.5;
        });
      },
      callbackScope: this,
      loop: true
    });

  },
  restartScrollerAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.dragSprites,
      alpha: {
        start: 1,
        to: 0,
      },
      duration: duration,
      delay: 0,
      ease:'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        self.dragSprites.forEach(sprite => {
          sprite.y = self.scaler.scaleY(sprite.keepData.designY);
        });
        self.tweens.add({
          targets: self.dragSprites,
          alpha: {
            start: 0,
            to: 1,
          },
          duration: duration,
          delay: 0,
          ease:'Linear',
          repeat: 0,
          yoyo: false,
          onComplete: function () {
            self.autoScroller();
          },
        });
      },
    });
  },

  btnRightAnimation: function(btnSprite) {
    if(btnSprite.tween) {
      btnSprite.tween.remove();
    }
    btnSprite.tween = this.tweens.add({
      targets: btnSprite,
      x: {
        start: this.scaler.scaleX(this.scaler.designRefWidth() + btnSprite.keepData.designX - 15),
        to: this.scaler.scaleX(this.scaler.designRefWidth() + btnSprite.keepData.designX),
      },
      duration: 150,
      delay: 0,
      ease: 'Quintic.easeInOut',
      repeat: -1,
      repeatDelay: 200,
      // loopDelay: 3000,
      yoyo: true,
      onComplete: function () {
      },
    });
  },

});
export default SceneSystemPreface;